import Vue from 'vue';
import Vuex from 'vuex';

// import modules
import auth from './stores/auth';
import config from './stores/config';
import dadata from './stores/dadata';
import geometry from './stores/geometry';
import gallery from './stores/gallery';
import fields from './stores/fields';
import opportunities from './stores/opportunities';
import news from './stores/news';
import competitions from './stores/competitions';
import internship from './stores/internship';
import projects from './stores/projects';
import statistics from './stores/statistics';
import examples from './stores/examples';
import pumps from './stores/pumps';
import gains from './stores/gains';
import account from './stores/account';
import popup from './stores/popup';
import dialog from './stores/dialog';
import search from './stores/search';
import usersSearch from './stores/users-search';
import chat from './stores/chat';
import rMain from './stores/r-main';
import userData from './stores/user-data';
import aboutUs from './stores/about-us';
import training from './stores/training';
import competences from './stores/competences';
import dictionary from './stores/dictionary';
import education from './stores/education';
import career from './stores/career';
import docs from './stores/docs';
import contactsDocs from './stores/contacts-docs';
import tests from './stores/tests';
import notify from './stores/notifications';
import notifyApp from './stores/notificationsApp';
import snackbars from './stores/snackbars';
import participationInProjects from './stores/participation-in-projects';
import newCompetences from './stores/new-competences';
import professions from './stores/professions';
import examination from '@/stores/examination';
import newExamination from '@/stores/new-examination';
import users from '@/stores/users';
import newUsers from '@/stores/new-users';
import settings from '@/stores/settings';
import hashtags from '@/stores/hashtags';
import proposals from '@/stores/proposals';
import track from '@/stores/track';
import testing from '@/stores/testing';
import platform from '@/stores/platform';
import exam from '@/stores/exam';
import { events } from '@/stores/events';
import mentoring from '@/stores/mentoring';
import questionnaires from '@/stores/questionnaires';
import calendarEvents from '@/stores/calendar-events';
import accountTrack from '@/stores/account-track';
import accountCompetences from '@/stores/account-competences';
import singleProfession from '@/stores/single-profession';
import data from '@/stores/data';
import reporting from '@/stores/reporting';
import trip from '@/stores/trip';
import legal from '@/stores/legal';
import educationInfo from '@/stores/education-info';
import deleteProfile from '@/stores/delete-profile';
import appLoader from '@/stores/app-loader';
import telConfirmation from './stores/tel-confirmation';
import emailConfirmation from './stores/email-confirmation';
import roleAttributes from './stores/role-attributes';

import popupsController from './stores/popups-controller';

Vue.use(Vuex);

let store = null;

export const getStore = (modules = {}) => {
    if (store === null) {
        store = new Vuex.Store({
            modules: {
                auth,
                config,
                dadata,
                geometry,
                gallery,
                fields,
                opportunities,
                news,
                competitions,
                projects,
                internship,
                // courses,
                // events,
                // webinars,
                statistics,
                examples,
                pumps,
                gains,
                account,
                popup,
                dialog,
                search,
                usersSearch,
                chat,
                rMain,
                userData,
                aboutUs,
                training,
                competences,
                dictionary,
                education,
                career,
                docs,
                contactsDocs,
                tests,
                notify,
                notifyApp,
                snackbars,
                participationInProjects,
                newCompetences,
                professions,
                examination,
                newExamination,
                users,
                newUsers,
                settings,
                hashtags,
                track,
                testing,
                platform,
                events,
                proposals,
                mentoring,
                calendarEvents,
                exam,
                questionnaires,
                accountTrack,
                accountCompetences,
                singleProfession,
                popupsController,
                data,
                reporting,
                trip,
                legal,
                educationInfo,
                deleteProfile,
                appLoader,
                telConfirmation,
                emailConfirmation,
                roleAttributes,
                ...modules,
            },
            getters: {
                user: (state, getters, rootState, rootGetters) => rootGetters['auth/user'],
                getUserRoles: (state, getters, rootState, rootGetters) => rootGetters['auth/getUserRoles'],
                isAuthorized: (state, getters, rootState, rootGetters) => rootGetters['auth/isAuthorized'],
                userHasAccess: (state, getters, rootState, rootGetters) => rootGetters['auth/userHasAccess'],
            },
        });
    }

    return store;
};
